import script from "./file-view.vue?vue&type=script&setup=true&lang=js"
export * from "./file-view.vue?vue&type=script&setup=true&lang=js"

export default script